import React from 'react';
import { motion } from 'framer-motion';
import './StatCard.css';

/**
 * Reusable stat card component for displaying individual statistics
 */
const StatCard = ({ title, value, subtitle, icon, color, trend }) => {
  return (
    <motion.div
      className="stat-card"
      whileHover={{ y: -4, scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      <div className="stat-card-content">
        <div className="stat-icon" style={{ backgroundColor: `${color}20`, color }}>
          {icon}
        </div>

        <div className="stat-info">
          <span className="stat-title">{title}</span>
          <span className="stat-value">{value}</span>
          {subtitle && <span className="stat-subtitle">{subtitle}</span>}
        </div>

        {trend && (
          <div className={`stat-trend ${trend > 0 ? 'positive' : 'negative'}`}>
            {trend > 0 ? '+' : ''}{trend}%
          </div>
        )}
      </div>

      <div
        className="stat-card-accent"
        style={{ background: `linear-gradient(90deg, ${color}, transparent)` }}
      ></div>
    </motion.div>
  );
};

export default StatCard;
